export const formatDate = (date) => {
    const currentDate = new Date(date) || new Date(); // Use the provided date or the current date if not provided.
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const formatted = `${day}-${month}-${year}`;
    return formatted;
  };
